import type { DataDownloadDataset } from '@factorialco/f0-react'

/**
 * Generate a CSV string from a dataset and trigger a browser download.
 *
 * The first version of the factorial-side data download offers CSV only;
 * Excel was supported in the original f0 component via xlsx, which is not
 * a dependency of factorial. Add an Excel exporter here if/when the
 * frontend ships an xlsx library.
 */
export function downloadAsCsv(dataset: DataDownloadDataset, filename: string): void {
  const { columns, rows, columnLabels } = dataset
  const headers = columns.map((col) => columnLabels?.[col] ?? col)

  const escapeCsv = (value: unknown): string => {
    const str = value == null ? '' : String(value)
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`
    }
    return str
  }

  const lines = [
    headers.map(escapeCsv).join(','),
    ...rows.map((row) => columns.map((col) => escapeCsv(row[col])).join(',')),
  ]

  const blob = new Blob([lines.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  })

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${filename}.csv`
  link.click()
  URL.revokeObjectURL(link.href)
}
